import React from "react";

const FEATURES_DATA = [
  { label: "Dashboard", value: 140 },
  { label: "Members", value: 90 },
  { label: "Sales", value: 70 },
  { label: "Reports", value: 50 },
  { label: "Settings", value: 30 },
];

const MAX_VAL = 160;
const X_TICKS = [0, 40, 80, 120, 160];

const AnalyticsFeaturesChart = () => {
  return (
    <div className="v2-analytics-pg-features">
      <div className="v2-analytics-pg-features__header">
        <h3 className="v2-analytics-pg-features__title">Most Used Features</h3>
        <p className="v2-analytics-pg-features__subtitle">
          Features you access most frequently
        </p>
      </div>
      <div className="v2-analytics-pg-features__chart">
        {FEATURES_DATA.map((item) => (
          <div className="v2-analytics-pg-features__row" key={item.label}>
            <span className="v2-analytics-pg-features__label">{item.label}</span>
            <div className="v2-analytics-pg-features__bar-track">
              <div
                className="v2-analytics-pg-features__bar-fill"
                style={{ width: `${(item.value / MAX_VAL) * 100}%` }}
              />
            </div>
          </div>
        ))}
        <div className="v2-analytics-pg-features__x-axis">
          {X_TICKS.map((tick) => (
            <span key={tick} className="v2-analytics-pg-features__x-label">
              {tick}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsFeaturesChart;
